<template>
  <div id="app">
    <router-view />
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppFooter,
  },
};
</script>

<style>
/* Pied de page repoussé en bas de l'écran sur les pages courtes */
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
